import ChartingHighchartsBaseController from './charting_highcharts_base_controller';
import { adaptiveTreemapLabel } from '../../lib/adaptive_treemap_label';

export default class extends ChartingHighchartsBaseController {
  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  resolveClickValue(point, _member) {
    return point.name;
  }

  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  tooltipFormatter(ctx) {
    let html = `<b>${ctx.point.name || ctx.series.name}</b><br/>${ctx.point.value ?? ctx.y}`;

    if (ctx.point.tooltip) {
      html += `<br/>${ctx.point.tooltip}`;
    }

    return html;
  }

  buildConfig() {
    const config = super.buildConfig();
    return { ...config, plotOptions: this.#adaptivePlotOptions(config.plotOptions) };
  }

  #adaptivePlotOptions(plotOptions) {
    const fontFamily = this.theme('typography-font-family');

    return Object.fromEntries(
      Object.entries(plotOptions || {}).map(([seriesType, seriesOptions]) => {
        const { adaptive, format, ...dataLabels } = seriesOptions.dataLabels || {};
        if (!adaptive) return [seriesType, seriesOptions];

        const color = dataLabels.style?.color;
        return [seriesType, {
          ...seriesOptions,
          dataLabels: {
            ...dataLabels,
            useHTML: true,
            formatter() {
              return adaptiveTreemapLabel(this.point, { fontFamily, color });
            }
          }
        }];
      })
    );
  }
}
